/* @flow */
import React from 'react';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { resolveTestId } from '@cvent/nucleus-test-automation';

type NumberOfCircles = 1 | 2 | 3 | '1' | '2' | '3';

type Props = {
  /** The number of circles to display, defaults to 3 */
  numberOfCircles: NumberOfCircles,
  /** Text used for screen reader, and hidden from sighted users. */
  fallbackText?: string,
  classes?: {
    /** Top level style applied to the container. */
    container?: string,
    /** Style applied to fallback text. */
    hidden?: string,
    /** Style applied to the outer circle. */
    outerCircle?: string,
    /** Style applied to the middle circle. */
    middleCircle?: string,
    /** Style applied to the inner circle. */
    innerCircle?: string
  },
  /** Available Style Keys. */
  style?: {
    /** Top level style applied to the container. */
    container?: any,
    /** Style applied to fallback text. */
    hidden?: any,
    /** Style applied to the outer circle. */
    outerCircle?: any,
    /** Style applied to the middle circle. */
    middleCircle?: any,
    /** Style applied to the inner circle. */
    innerCircle?: any
  }
};

type DefaultProps = {
  numberOfCircles: NumberOfCircles
};

/**
Spinner with three nested circles spinning at different speed.
**/
export default class Spinner extends React.PureComponent<DefaultProps, Props, void> {
  static displayName = 'Spinner';
  static defaultProps = {
    numberOfCircles: 3
  };
  render() {
    const numberOfCircles = parseInt(this.props.numberOfCircles, 10);
    const { fallbackText } = this.props;
    return (
      <div {...resolve(this.props, 'container')} {...resolveTestId(this.props)}>
        {
          fallbackText &&
            <div {...resolve(this.props, 'hidden')}>{fallbackText}</div>
        }
        <div {...resolve(this.props, 'outerCircle')} />
        {numberOfCircles > 1 && <div {...resolve(this.props, 'middleCircle')} />}
        {numberOfCircles > 2 && <div {...resolve(this.props, 'innerCircle')} />}
      </div>
    );
  }
}
